/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DocumentTypeFromJSON, DocumentTypeToJSON } from './';
export function CreateDocumentDataFromJSON(json) {
    return CreateDocumentDataFromJSONTyped(json, false);
}
export function CreateDocumentDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        title: json['title'],
        config: !exists(json, 'config') ? undefined : json['config'],
        description: !exists(json, 'description') ? undefined : json['description'],
        type: !exists(json, 'type') ? undefined : DocumentTypeFromJSON(json['type']),
        ParentId: json['ParentId'],
        gridLocked: json['gridLocked'],
    };
}
export function CreateDocumentDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        title: value.title,
        config: value.config,
        description: value.description,
        type: DocumentTypeToJSON(value.type),
        ParentId: value.ParentId,
        gridLocked: value.gridLocked,
    };
}
